const REACT_APP_CLAIM_BASE_URL = process.env.REACT_APP_CLAIM_BASE_URL;

const deleteDataClaim = async (data: any, uri: any) => {
  const response = await fetch(`${REACT_APP_CLAIM_BASE_URL}/${uri}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default deleteDataClaim;
